import type { ButtonHTMLAttributes } from "react";
import { cn } from "../../utils/cn";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "magic" | "magic-reversed";
}

export const Button = ({
  variant = "secondary",
  className,
  children,
  ...props
}: Props) => (
  <button
    type="button"
    className={cn(
      "rounded-xl px-4 py-2 text-sm font-medium active:scale-90 transition-all duration-100",
      variant !== "magic" && variant !== "magic-reversed" && "hover:font-bold",
      "disabled:opacity-50 disabled:active:scale-100 disabled:hover:font-medium disabled:cursor-not-allowed",
      variant === "primary" &&
        "bg-red-1 hover:bg-red-2 border border-red-2 text-red-3 disabled:hover:bg-red-1",
      variant === "secondary" &&
        "bg-gray-1 hover:bg-gray-3 disabled:hover:bg-gray-1",
      variant === "magic" &&
        "relative overflow-hidden bg-[linear-gradient(90deg,rgba(57,220,234,0.05)_10%,rgba(255,40,166,0.05)_88%)] before:absolute before:inset-0 before:bg-[linear-gradient(90deg,rgba(255,40,166,0.05)_10%,rgba(57,220,234,0.05)_88%)] before:opacity-0 hover:before:opacity-100 before:transition-opacity before:duration-300 before:ease-in-out disabled:before:opacity-0",
      variant === "magic-reversed" &&
        "relative overflow-hidden bg-[linear-gradient(90deg,rgba(255,40,166,0.05)_10%,rgba(57,220,234,0.05)_88%)] before:absolute before:inset-0 before:bg-[linear-gradient(90deg,rgba(57,220,234,0.05)_10%,rgba(255,40,166,0.05)_88%)] before:opacity-0 hover:before:opacity-100 before:transition-opacity before:duration-300 before:ease-in-out disabled:before:opacity-0",
      className,
    )}
    {...props}
  >
    <span
      className={
        variant === "magic" || variant === "magic-reversed"
          ? "relative z-10"
          : undefined
      }
    >
      {children}
    </span>
  </button>
);
